import React, { useEffect, useState, useRef } from 'react'
import { Divider, Input, Form, Select } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { Vertical, Horizontal, GraviButton, Texto } from '@gravitate-js/excalibrr'
const { Option } = Select
export const ManifoldSelect = ({ name, availableManifolds, placeholder, tank }) => {
  const [itemToAdd, setItemToAdd] = useState()
  const [managedOptions, setManagedOptions] = useState([])
  const [itemValid, setItemValid] = useState(false)
  useEffect(() => {
    if (availableManifolds) {
      setManagedOptions(availableManifolds)
    }
  }, [availableManifolds])
  const createNewItem = () => {
    const optionsCopy = [...managedOptions]
    setItemToAdd('')
    optionsCopy.push({ manifold_id: itemToAdd, tanks: [tank?.tank_id] })
    availableManifolds.push({ manifold_id: itemToAdd, tanks: [tank?.tank_id] })
    setManagedOptions(optionsCopy)
    setItemValid(false)
  }
  const checkAndChange = (value) => {
    setItemValid(value.length > 3)
    setItemToAdd(value)
  }

  const wrapperRef = useRef(null)

  return (
    <div ref={wrapperRef}>
      <Form.Item key={name} name={name} className='mb-0'>
        <Select
          getPopupContainer={(_) => wrapperRef?.current}
          placeholder={placeholder}
          allowClear
          dropdownRender={(menu) => (
            <div>
              {menu}
              <Divider style={{ margin: '4px 0' }} />
              <div className='p-3'>
                <Texto className='pb-2' weight={600} appearance='medium'>
                  New Manifold
                </Texto>
                <Horizontal>
                  <Vertical flex={2}>
                    <Input
                      style={{ width: '100%' }}
                      value={itemToAdd}
                      onChange={(event) => checkAndChange(event.target.value)}
                    />
                  </Vertical>
                  <Vertical alignItems='flex-end'>
                    <GraviButton
                      theme2
                      type='link'
                      style={{ width: 100 }}
                      onClick={createNewItem}
                      disabled={!itemValid}
                      buttonText='Add Item'
                      icon={<PlusOutlined />}
                    />
                  </Vertical>
                </Horizontal>
              </div>
            </div>
          )}
        >
          {managedOptions.map((v) => (
            <Option key={v.manifold_id} value={v.manifold_id}>
              {v.manifold_id} {v.tanks.map((tankId) => tankId && `:  ${tankId}`)}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  )
}
